export const formatUnderscoreLabel = (val) => {
  if (!val) return "-";
  return val
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};